import { spCredlyManagementBadgeSearchLocs } from './components/badge-search/badge-search.locs';
import { spCredlyManagementCredlyDataLocs } from './components/candidate-credly-data/candidate-credly-data.locs';
import { spToolsCredlyDuplicatesLocs } from './components/credly-duplicate-management/credly-duplicate-management.locs';
import { spCredlyManagementLocs } from './components/credly-management/credly-management.locs';
import { spCredlyManagementSearchFormLocs } from './components/search-form/credly-search-form.locs';
import { spToolCredlyTemplateExceptionsLocs } from './components/templates/credly-exceptions/credly-exceptions.locs';
import { spToolCredlyTemplatesDuplicateIdsLocs } from './components/templates/duplicate-ids/duplicate-ids.locs';
import { spToolCredlyTemplatesExpireDateModalLocs } from './components/templates/expire-date-modal/expire-date-modal.locs';
import { spToolCredlyTemplatesLocs } from './components/templates/templates.locs';

export const credlyModuleLocs = {
	...spToolCredlyTemplatesLocs,
	...spCredlyManagementLocs,
	...spToolsCredlyDuplicatesLocs,
	...spCredlyManagementSearchFormLocs,
	...spCredlyManagementBadgeSearchLocs,
	...spCredlyManagementCredlyDataLocs,
	...spToolCredlyTemplatesDuplicateIdsLocs,
	...spToolCredlyTemplateExceptionsLocs,
	...spToolCredlyTemplatesExpireDateModalLocs,
};
